import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpandIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "266px",
	height: "264px",
	viewBox: "0 0 266 264",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Expand" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			x: "-1900.0%",
			y: "-7.9%",
			width: "3900.0%",
			height: "115.7%",
			filterUnits: "objectBoundingBox",
			id: "filter-1",
			children: [
				/* @__PURE__ */ _jsx("feOffset", {
					dx: 0,
					dy: 2,
					in: "SourceAlpha",
					result: "shadowOffsetOuter1"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 2,
					in: "shadowOffsetOuter1",
					result: "shadowBlurOuter1"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0",
					in: "shadowBlurOuter1",
					result: "shadowMatrixOuter1"
				}),
				/* @__PURE__ */ _jsxs("feMerge", { children: [/* @__PURE__ */ _jsx("feMergeNode", { in: "shadowMatrixOuter1" }), /* @__PURE__ */ _jsx("feMergeNode", { in: "SourceGraphic" })] })
			]
		}) }),
		/* @__PURE__ */ _jsxs("g", {
			id: "Page-1",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ _jsx("line", {
				x1: 7.5,
				y1: 47.5,
				x2: 7.5,
				y2: 208.5,
				id: "Line",
				stroke: "#000000",
				strokeWidth: 15,
				strokeLinecap: "square"
			}), /* @__PURE__ */ _jsx("g", {
				id: "arrowsoutline",
				transform: "translate(31.000000, 47.000000)",
				fill: "#000000",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M158.246269,2.49652245 C155.044776,-0.832174149 149.716418,-0.832174149 146.402985,2.49652245 C143.201493,5.71276307 143.201493,11.0656671 146.402985,14.2744106 L206.455224,74.6032879 L8.29104478,74.6032879 C3.67164179,74.6107849 0,78.2993406 0,82.9400235 C0,87.5807063 3.67164179,91.3892151 8.29104478,91.3892151 L206.455224,91.3892151 L146.402985,151.605636 C143.201493,154.934333 143.201493,160.294734 146.402985,163.503478 C149.716418,166.832174 155.052239,166.832174 158.246269,163.503478 L232.514925,88.8926926 C235.828358,85.676452 235.828358,80.323548 232.514925,77.1148044 L158.246269,2.49652245 Z",
					id: "Path"
				})
			})]
		})
	]
});
export default SvgExpandIcon;
